module.exports = __webpack_public_path__ + "static/media/company-dark.94ef294b.png";